module.exports = __webpack_public_path__ + "9fff2e897a19d7e2fd9d2c19488a66d5.png";